import api from '@/shared/utils/apiConfig';

export interface AppointmentTypeActorRef {
  id: string;
  name: string;
}

export interface AppointmentTypeBookingPolicyOverride {
  overlap?: {
    dentist?: 'block' | 'warn' | 'allow';
    chair?: 'block' | 'warn' | 'allow';
  };
}

export interface AppointmentType {
  id: string;
  name: string;
  code: string;
  isSystem: boolean;
  isActive: boolean;
  color?: string;
  defaultDuration?: number;
  bookingPolicyOverride?: AppointmentTypeBookingPolicyOverride;
  createdBy?: AppointmentTypeActorRef;
  updatedBy?: AppointmentTypeActorRef;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateAppointmentTypePayload {
  name: string;
  color?: string | null;
  defaultDuration?: number | null;
  bookingPolicyOverride?: AppointmentTypeBookingPolicyOverride | null;
}

export interface UpdateAppointmentTypePayload {
  name?: string;
  isActive?: boolean;
  color?: string | null;
  defaultDuration?: number | null;
  bookingPolicyOverride?: AppointmentTypeBookingPolicyOverride | null;
}

interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  count?: number;
  message?: string;
}

export const appointmentTypeAPI = {
  getAll: async (includeInactive = false): Promise<ApiResponse<AppointmentType[]>> => {
    const response = await api.get('/appointment-types', {
      params: includeInactive ? { includeInactive: 'true' } : undefined,
    });
    return response.data;
  },

  create: async (payload: CreateAppointmentTypePayload): Promise<ApiResponse<AppointmentType>> => {
    const response = await api.post('/appointment-types', payload);
    return response.data;
  },

  update: async (
    id: string,
    payload: UpdateAppointmentTypePayload
  ): Promise<ApiResponse<AppointmentType>> => {
    const response = await api.put(`/appointment-types/${id}`, payload);
    return response.data;
  },

  deactivate: async (id: string): Promise<ApiResponse<AppointmentType>> => {
    const response = await api.delete(`/appointment-types/${id}`);
    return response.data;
  },
};
